/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const DEFAULT_VISIBLE_PAGES = 5;

const getPageWindow = (currentPage, totalPages, visiblePages) => {
  let startPage = 1;

  if (totalPages <= visiblePages) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - visiblePages + 1;
  } else {
    startPage = currentPage - 2;
  }

  if (startPage < 1) startPage = 1;

  const endPage = Math.min(startPage + visiblePages - 1, totalPages);
  const pages = [];
  for (let page = startPage; page <= endPage; page++) {
    pages.push(page);
  }
  return pages;
};

const PaginationItem = ({
  itemClass,
  linkClass,
  active,
  disabled,
  onClick,
  ariaLabel,
  children,
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.currentTarget.blur();
    if (!disabled) onClick();
  };

  const liClass = [itemClass, active ? "active" : "", disabled ? "disabled" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <li className={liClass}>
      <a href="#" className={linkClass} onClick={handleClick} aria-label={ariaLabel}>
        {children}
      </a>
    </li>
  );
};

const Pagination = ({
  itemClass = "page-item",
  linkClass = "page-link",
  activePage = 1,
  itemsCountPerPage = 10,
  totalItemsCount = 0,
  onChange,
}) => {
  if (!totalItemsCount || totalItemsCount <= 0) {
    return null;
  }

  const totalPages = Math.max(
    1,
    Math.ceil(totalItemsCount / Math.max(itemsCountPerPage, 1))
  );
  const currentPage = Math.min(Math.max(activePage, 1), totalPages);
  const hasPreviousPage = currentPage > 1;
  const hasNextPage = currentPage < totalPages;
  const pages = getPageWindow(currentPage, totalPages, DEFAULT_VISIBLE_PAGES);

  return (
    <ul className="pagination" style={{ margin: 0 }}>
      <PaginationItem
        itemClass={itemClass}
        linkClass={linkClass}
        disabled={!hasPreviousPage}
        onClick={() => onChange(1)}
        ariaLabel="First"
      >
        «
      </PaginationItem>

      <PaginationItem
        itemClass={itemClass}
        linkClass={linkClass}
        disabled={!hasPreviousPage}
        onClick={() => onChange(currentPage - 1)}
        ariaLabel="Previous"
      >
        ‹
      </PaginationItem>

      {pages.map((page) => (
        <PaginationItem
          key={page}
          itemClass={itemClass}
          linkClass={linkClass}
          active={page === currentPage}
          onClick={() => onChange(page)}
          ariaLabel={`Page ${page}`}
        >
          {page}
        </PaginationItem>
      ))}

      <PaginationItem
        itemClass={itemClass}
        linkClass={linkClass}
        disabled={!hasNextPage}
        onClick={() => onChange(currentPage + 1)}
        ariaLabel="Next"
      >
        ›
      </PaginationItem>

      <PaginationItem
        itemClass={itemClass}
        linkClass={linkClass}
        disabled={!hasNextPage}
        onClick={() => onChange(totalPages)}
        ariaLabel="Last"
      >
        »
      </PaginationItem>
    </ul>
  );
};

export default Pagination;
